import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	plansWelcomeModalTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.plans-welcome-modal-title',
		defaultMessage: 'Welcome to Plans',
		description: 'Welcome modal title text',
	},
	plansWelcomeModalContentSpork: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.plans-welcome-modal-content-spork',
		defaultMessage:
			'Plans is designed to help you ship larger pieces of work faster and more reliably by building smarter plans. Get visibility into work happening across Jira, track dependencies across teams, plan with team capacity in mind, and communicate status across your organization.',
		description: 'Welcome modal content text',
	},
	welcomeModalSkipTour: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.welcome-modal-skip-tour',
		defaultMessage: 'Skip tour',
		description: 'Welcome modal skip tour button text',
	},
	welcomeModalGetStarted: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.welcome-modal-get-started',
		defaultMessage: 'Get started',
		description: 'Welcome modal get started button text',
	},
	nextButton: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.next-button',
		defaultMessage: 'Next',
		description: 'Text of the next button',
	},
	finishButton: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.finish-button',
		defaultMessage: 'Got it',
		description: 'Text of the finish button',
	},
	updateJiraCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.update-jira-card-title',
		defaultMessage: 'Saving changes',
		description: 'Title text of the update jira card',
	},
	updateJiraCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.update-jira-card-content',
		defaultMessage:
			"Any changes you make are automatically kept here until you're ready to save them to Jira.",
		description: 'Content text of the update jira card',
	},
	updateJiraCardAdditionalContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.update-jira-card-additional-content',
		defaultMessage: 'If changes are no longer needed, you can easily discard them.',
		description: 'Second line text of the update jira card',
	},
	scopeCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-title',
		defaultMessage: 'Manage your issues',
		description: 'Title text of the scope card',
	},
	scopeCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-content',
		defaultMessage: 'Issues within this plan will appear in the scope section.',
		description: 'Content text of the scope card',
	},
	scopeCardAdditionalContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-additional-content',
		defaultMessage:
			'Here you can create new issues, rank issues by dragging them up or down, and organize issues into {link}.',
		description: 'Second line text of the scope card',
	},
	scopeCardAdditionalContentHierarchyLink: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.scope-card-additional-content-hierarchy-link',
		defaultMessage: 'hierarchy levels',
		description: 'Hierarchy link text of the scope card',
	},
	fieldsCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.fields-card-title',
		defaultMessage: 'Edit issues',
		description: 'Title text of the fields card',
	},
	fieldsCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.fields-card-content',
		defaultMessage: 'Make changes to your issues in the fields section.',
		description: 'Content text of the fields card',
	},
	fieldsCardAdditionalContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.fields-card-additional-content',
		defaultMessage:
			'Need more fields? Click on the Fields > button to show and hide fields such as team, dependencies, estimate, custom fields, and more.',
		description: 'Additional content text of the fields card',
	},
	timelineCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.timeline-card-title',
		defaultMessage: 'Visualize dates',
		description: 'Title text of the fields card',
	},
	timelineCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.timeline-card-content',
		defaultMessage: 'See when issues and releases are scheduled in the timeline.',
		description: 'Content text of the fields card',
	},
	timelineCardAdditionalContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.timeline-card-additional-content',
		defaultMessage: 'To show an issue on the timeline simply drag and drop, or set date fields.',
		description: 'Additional content text of the fields card',
	},
	doneFlagTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.done-flag-title',
		defaultMessage: 'Happy planning!',
		description: 'Title of the onboarding done flag',
	},
	plansDoneFlagContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.plans-done-flag-content',
		defaultMessage:
			'For more information on how to get started with Plans, check out our latest documentation.',
		description: 'Content of the onboarding done flag',
	},
	doneFlagViewDocumentationLink: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.done-flag-view-documentation-link',
		defaultMessage: 'View documentation',
		description: 'View documentation link text',
	},
	filtersViewSettingsCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.filters-view-settings-card-title',
		defaultMessage: 'Customize your roadmap',
		description: 'Title text of the view settings card',
	},
	filtersViewSettingsCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.filters-view-settings-card-content',
		defaultMessage:
			'Choose which issues to show in your plan using filters, then decide how they’re displayed using the View settings menu.',
		description: 'Content text of the view settings card',
	},
	tabSwitchingCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.tab-switching-card-title',
		defaultMessage: 'View plan information',
		description: 'Title text of the tab switching card',
	},
	tabSwitchingCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.tab-switching-card-content',
		defaultMessage:
			'Navigate between the Roadmap view, teams and releases included in your plan, and the dependencies report.',
		description: 'Content text of the tab switching card',
	},
	savedViewsDropdownCardTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.saved-views-dropdown-card-title',
		defaultMessage: 'Create and switch views',
		description: 'Title text of the saved view dropdown card',
	},
	savedViewsDropdownCardContent: {
		id: 'portfolio-3-portfolio.app-simple-plans.onboarding.saved-views-dropdown-card-content',
		defaultMessage:
			'Save your current filters and settings as a view that can later be recalled. You can also switch between the different views based on what information you wish to highlight.',
		description: 'Content text of the saved view dropdown card',
	},
});

export default messages;
